import { Button, Col, Row } from 'react-bootstrap';
import EditIcon from '../../assets/images/EditIcon';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocalizedRoutes } from '../../hooks/useLocalizedRoutes';

export const CuentaFacturacionCard = ({ cuenta, countryCode }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getPath } = useLocalizedRoutes();
  const displayedCity =
    cuenta.city || cuenta.locality || cuenta.township || '';
  const secondaryLocationParts = [
    cuenta.township && cuenta.township !== displayedCity ? cuenta.township : '',
    cuenta.district || '',
    cuenta.province || '',
  ].filter(Boolean);
  const billingPeriodLabel =
    {
      '0': t('datos.facturacion.form.periodo-facturacion.sin-periodo'),
      '1': t('datos.facturacion.form.periodo-facturacion.mensual'),
      '2': t('datos.facturacion.form.periodo-facturacion.repostaje'),
    }[String(cuenta.period ?? '0')] ||
    t('datos.facturacion.form.periodo-facturacion.sin-periodo');

  const handleEdit = () => {
    navigate(getPath('billingEdit'), {
      state: { id: cuenta.billingAccountId },
    });
  };

  const handleDelete = () => {
    console.log('Eliminando cuenta', cuenta.billingAccountId);
  };

  return (
    <Row className='facturas-account-card mb-3'>
      <Col sm={7} md={8}>
        <Row className='facturas-cuentas-info'>
          <Col sm={1} md={8}>
            <p className='facturas-cuentas-info-title'>
              <span className='facturas-cuentas-info-name'>
                {cuenta.name} {cuenta.lastName}
              </span>
              <span className='facturas-cuentas-info'>
                {cuenta.accountType === 'Empresa'
                  ? t('datos.facturacion.form.tipo-cuenta.empresa')
                  : t('datos.facturacion.form.tipo-cuenta.fisico')}
              </span>
            </p>

            <p className='facturas-cuentas-info facturas-cuentas-info-inline'>
              <span>{cuenta.nip} {countryCode && <span>({countryCode})</span>}</span>
            </p>
            <p className='facturas-cuentas-info'>
              {cuenta.address}
              {cuenta.postalCode ? `, ${cuenta.postalCode}` : ''}
              {displayedCity ? `, ${displayedCity}` : ''}
            </p>
            <p className='facturas-cuentas-info'>
              {secondaryLocationParts.join(', ')}
            </p>
            <p className='facturas-cuentas-info'>
              {t('datos.facturacion.form.periodo-facturacion')}:
              {' '}
              {billingPeriodLabel}
            </p>
          </Col>
        </Row>
      </Col>
      <Col sm={5} md={4} className='text-end'>
        <Col className='facturas-mas-btns'>
          <Button variant='outline-primary-no-border' onClick={handleEdit}>
            <EditIcon color='#db0b27' width={28} height={28} />
          </Button>
          {/* <Button variant="outline-primary-no-border" onClick={handleDelete}>
            <DeleteIcon color="#db0b27" width={28} height={28} />
          </Button> */}
        </Col>
      </Col>
    </Row>
  );
};
